"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSize = exports.ButtonType = void 0;
var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "ff-button-primary";
    ButtonType["Alternate"] = "ff-button-alternate";
    ButtonType["Success"] = "ff-button-success";
    ButtonType["Warning"] = "ff-button-warning";
    ButtonType["Failure"] = "ff-button-failure";
    ButtonType["Gray"] = "ff-button-gray";
    ButtonType["Gray2"] = "ff-button-gray2";
    ButtonType["Gray3"] = "ff-button-gray3";
    ButtonType["Gray4"] = "ff-button-gray4";
    ButtonType["Gray5"] = "ff-button-gray5";
    ButtonType["Gray6"] = "ff-button-gray6";
    ButtonType["White"] = "ff-button-white";
})(ButtonType || (ButtonType = {}));
exports.ButtonType = ButtonType;
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Small"] = "small";
    ButtonSize["Normal"] = "";
    ButtonSize["Medium"] = "";
    ButtonSize["Large"] = "";
    ButtonSize["XLarge"] = "";
})(ButtonSize || (ButtonSize = {}));
exports.ButtonSize = ButtonSize;
//# sourceMappingURL=ButtonProps.js.map